import { render, staticRenderFns } from "./CompanyBrandSelect_1.vue?vue&type=template&id=30d85d06&scoped=true&"
import script from "./CompanyBrandSelect_1.vue?vue&type=script&lang=js&"
export * from "./CompanyBrandSelect_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d85d06",
  null
  
)

export default component.exports